import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 样式
import '@/assets/styles/global.css'
import '@/assets/styles/reset.css'
import '@/assets/styles/control.css'
// 环境变量
import '@/config'
// 全局变量及方法
import '@/utils/global/extend'
import core from '@/utils/global/core'
import format from '@/utils/global/format'
import params from '@/utils/global/params'
import VueIntro from 'vue-introjs'
// 剪切板
import VueClipboard from 'vue-clipboard2'
// 按需引入 element-ui
import { Button, Loading, Message, Table, TableColumn, Pagination, Select, Option, Input, Dialog, DatePicker, Form, FormItem, Row, Col, Checkbox, Radio, Tooltip, Link, Progress, Carousel, CarouselItem, RadioGroup, Tabs, TabPane, InputNumber, Autocomplete } from 'element-ui'
import ElementLocale from 'element-ui/lib/locale'
// 自定义element组件样式
import '@/assets/styles/element/index.js'
// 国际化
import i18n from '@/lang'
// 全局组件
import '@/components'
// 全局指令
import '@/utils/directives'
// 全局过滤器
import '@/utils/filters'
// 自定义组件
import TMessageBox from '@/components/tMessageBox'
import TLoading from '@/components/tLoading'
DatePicker.props.clearable = false
Vue.use(core)
Vue.use(format)
Vue.use(params)
Vue.use(VueClipboard)

Vue.use(Button)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Autocomplete)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Checkbox)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Radio)
Vue.use(Tooltip)
Vue.use(Row)
Vue.use(Col)
Vue.use(Link)
Vue.use(Progress)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(RadioGroup)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(InputNumber)

Vue.use(VueIntro)

// 由于element-ui对于Message的架构设计，并无install方法。所以这里不能调用Vue.use()。如果想用this.$message，请使用Vue.prototype.$mesage=Message来手动注册
// Vue.use(Message)

ElementLocale.i18n((key, value) => i18n.t(key, value))
Vue.use(TLoading)
const msgObj = {
  center: true,
  duration: 3000,
  showClose: false
}

Vue.prototype.$tmessage = TMessageBox
Vue.prototype.$talert = TMessageBox.alert
Vue.prototype.$tconfirm = TMessageBox.confirm

Vue.prototype.$err = function (msg, obj) {
  Message({
    ...msgObj,
    ...obj,
    message: this.$t(msg),
    type: 'error'
  })
}

Vue.prototype.$success = function (msg, obj) {
  Message({
    ...msgObj,
    ...obj,
    message: this.$t(msg),
    type: 'success'
  })
}

Vue.prototype.$warn = function (msg, obj) {
  Message({
    ...msgObj,
    ...obj,
    message: this.$t(msg),
    type: 'warning'
  })
}

Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
